import ErrorMessage from "components/common/ErrorMessage";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { Select } from "components/common/Select";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import TranslationListTable from "components/dashboard/TranslationListTable";
import GraphCard from "components/dashboard/GraphCard";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";
import { fetchDashboardAppointments } from "slices/dashboardSlice";
import { fetchAppointments } from "slices/appointmentSlice";
import { DashboardSelector } from "slices/dashboardSlice";
import { fetchLanguages } from "slices/languageSlice";
import { languageSelector } from "slices/languageSlice";
import { setError } from "slices/dashboardSlice";
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import FullPageLoader from "components/common/FullPageLoader";
import { usePermissions } from "layouts/Admin";
import { fetchFacilities } from "slices/facilitiesSlice";
import { departmentsSelector } from "slices/departmentsSlice";
import { facilitiesSelector } from "slices/facilitiesSlice";
import { fetchDepartments } from "slices/departmentsSlice";
import { LegendButton } from "components/common/TableColor";
import { legends } from "components/common/TableColor";
import { fetchSchools } from "slices/schoolSlice";
import { schoolSelector } from "slices/schoolSlice";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import ConfirmationModal from "components/common/ConfirmationMessage";
import DateRangeFilter from "components/common/DateRangeFilter";
import { fetchInterpreterOptions } from "slices/interpreterSlice";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { fetchDashboardGraph } from "slices/dashboardSlice";
import { Link, useNavigate } from "react-router-dom";
import { fetchTranslationsList } from "slices/translationSlice";
import { appointmentsSelector } from "slices/appointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";




const LUNCH_ROW_STYLE = { background: '#2e7d3222' };
const LUNCH_EYE_STYLE = { background: '#2e7d32' };
const DAY_OFF_ROW_STYLE = { background: '#fd7e1433' };
const DAY_OFF_EYE_STYLE = { background: '#fd7e14' };

function Dashboard() {
  const { checkPermission } = usePermissions()
  const { appointments } = useSelector(appointmentsSelector);
  const dispatch = useDispatch()
  const { dashboard, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(DashboardSelector);
  const appointmentData = useSelector(appointmentsSelector);
  const { language: languages } = useSelector(languageSelector);
  const { school: schools } = useSelector(schoolSelector);
  const { departments } = useSelector(departmentsSelector);
  const { facilities } = useSelector(facilitiesSelector);
  const [downloading, setDownloading] = useState(false);
  const [activeLegends, setActiveLegends] = useState([0]);
  const [languageState, setLanguageState] = useState([]);
  const [statusValues, setStatusValues] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    sortBy: 'id',
    sortDirection: 'desc',
  });
  const interpreters = useSelector((state) => state.interpreter.interpreter);
  const navigate = useNavigate();
  const translationsState = useSelector((state) => state.translation) || {};
  const { translations = { data: [], total: 0 }, total: totalTranslations = 0, current_page: currentPageTranslation = 1, per_page = 10 } = translationsState;
  console.log("translationsState", translationsState);
  const defaultValues = {
    status: 'all',
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    interpreter: null,
  };
  const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, reset, getValues } = useForm({
    defaultValues: defaultValues
  });
  const [activeLegend, setActiveLegend] = useState(0);
  const [statusValue, setStatusValue] = React.useState('all');
  const [filters, setFilters] = useState({ ...defaultValues, include_lunch: true });
  const [showLunch, setShowLunch] = useState(true);
  const [showDayOff, setShowDayOff] = useState(true);
  const lunchRecords = appointmentData?.lunchRecords ?? [];

  // Update currentPageSize from actual API response
  useEffect(() => {
    if (appointmentData?.per_page) {
      setCurrentPageSize(appointmentData.per_page);
    }
  }, [appointmentData?.per_page]);

  useEffect(() => {
    dispatch(fetchDashboardAnalytics());
    dispatch(fetchDashboardGraph());

    const defaultTab = 'appointments';
    setActiveTab(defaultTab);

    const today = moment().format('YYYY-MM-DD');
    let apiParams = {
      pageLength: 10,
      sortBy: "id",
      sortDirection: "desc",
      start_date: today,
      end_date: today,
      include_lunch: true,
    };

    if (defaultTab === 'appointments') {
      setFilters(apiParams);
      setCurrentPageSize(10);
      dispatch(fetchAppointments(1, apiParams));
    }
  }, [dispatch]);

  const [activeTab, setActiveTab] = useState('appointments');
  // const fetchList = (page = 1, params = {}) => {
  //   dispatch(fetchTranslationsList(page, params));
  // };
  const fetchList = (page = 1, params = {}) => {
    const today = moment().format('YYYY-MM-DD');

    const finalParams = {
      pageLength: params?.pageLength || 10,
      sortBy: "id",
      sortDirection: "desc",
      date: today,
      search: params?.search || "",
    };

    return fetchTranslationsList(page, finalParams);
  };

  // const handleTabClick = (tabType) => {
  //   setActiveTab(tabType);

  //   let apiParams = {
  //     pageLength: 10,
  //     sortBy: "id",
  //     sortDirection: "desc"
  //   };

  //   const today = moment().format('YYYY-MM-DD');

  //   if (tabType === 'appointments') {
  //     apiParams = { ...apiParams, type: [0, 1], date: today };
  //     dispatch(fetchDashboardAppointments(1, apiParams));
  //   } else if (tabType === 'bilingual') {
  //     apiParams = { ...apiParams, type: 2, date: today };
  //     dispatch(fetchDashboardAppointments(1, apiParams));
  //   } else if (tabType === 'translations') {
  //     apiParams = { ...apiParams, date: today };
  //     dispatch(fetchTranslationsList(1, apiParams));
  //   }

  // };

  const handleTabClick = (tabType) => {
    setActiveTab(tabType);

    const today = moment().format('YYYY-MM-DD');

    let apiParams = {
      pageLength: 10,
      sortBy: "id",
      sortDirection: "desc",
      start_date: today,
      end_date: today
    };

    if (tabType === 'appointments') {
      apiParams = { ...apiParams, type: [0, 1, 4], include_lunch: true };
      setFilters(apiParams);
      dispatch(fetchAppointments(1, apiParams));
    }
    else if (tabType === 'bilingual') {
      apiParams = { ...apiParams, type: 2 };
      setFilters(apiParams);
      dispatch(fetchAppointments(1, apiParams));
    }
    else if (tabType === 'translations') {
      setFilters(apiParams);
      dispatch(fetchTranslationsList(1, apiParams));
    }
  };

  const graphData = dashboard?.graph;
  // interpreter request
  const type0Completed = graphData?.types?.[0]?.map(item => item.completed);
  const type0Assigned = graphData?.types?.[0]?.map(item => item.assigned);
  const type0Declined = graphData?.types?.[0]?.map(item => item.declined);
  const type0Cancelled = graphData?.types?.[0]?.map(item => item.cancelled);
  const type0Pending = graphData?.types?.[0]?.map(item => item.pending);
  const type0Available = graphData?.types?.[0]?.map(item => item.available);

  // interpreter requests for evening school
  const type1Completed = graphData?.types?.[1]?.map(item => item.completed);
  const type1Assigned = graphData?.types?.[1]?.map(item => item.assigned);
  const type1Declined = graphData?.types?.[1]?.map(item => item.declined);
  const type1Cancelled = graphData?.types?.[1]?.map(item => item.cancelled);
  const type1Pending = graphData?.types?.[1]?.map(item => item.pending);
  const type1Available = graphData?.types?.[1]?.map(item => item.available);

  // Billingyal Exam
  const type2Completed = graphData?.types?.[2]?.map(item => item.completed);
  const type2Assigned = graphData?.types?.[2]?.map(item => item.assigned);
  const type2Declined = graphData?.types?.[2]?.map(item => item.declined);
  const type2Cancelled = graphData?.types?.[2]?.map(item => item.cancelled);
  const type2Pending = graphData?.types?.[2]?.map(item => item.pending);
  const type2Available = graphData?.types?.[2]?.map(item => item.available);

  // Translation Request
  const type3Completed = graphData?.types?.[3]?.map(item => item.completed);
  const type3Assigned = graphData?.types?.[3]?.map(item => item.assigned);
  const type3Declined = graphData?.types?.[3]?.map(item => item.declined);
  const type3Cancelled = graphData?.types?.[3]?.map(item => item.cancelled);
  const type3Pending = graphData?.types?.[3]?.map(item => item.pending);
  const type3Available = graphData?.types?.[3]?.map(item => item.available);

  const [isFourteenDays, setIsFourteenDays] = useState(false);
  const tableRef = useRef(null);

  const viewAppointments = (type) => {
    if (type === 0 || type === 1) {
    const today = moment().format('YYYY-MM-DD');
    const filterParams = {
      start_date: today,
      end_date: today,
      type: type,
      pageLength: 10,
      sortBy: "id",
      sortDirection: "desc",
      include_lunch: true,
    };

    setValue("start_date", today);
    setValue("end_date", today);
    setValue("type", type);
    setFilters(filterParams);
    dispatch(fetchAppointments(1, filterParams));
    tableRef.current?.scrollIntoView({ behavior: "smooth" });
   } else if (type === 2) {
      navigate("/billingual-requests", {
        state: {
          filterByToday: true,
        },
      });
    }
    else if (type === 3) {
      navigate("/translations", {
        state: {
          filterByToday: true,
        },
      });
    }
  };
  const nextFourteenDaysAppointments = (type) => {
    if (type === 0 || type === 1) {
    const tomorrow = moment().add(1, 'day').format('YYYY-MM-DD');
    const fourteenDaysAfter = moment().add(14, 'days').format('YYYY-MM-DD');

    const filterParams = {
      start_date: tomorrow,
      end_date: fourteenDaysAfter,
      type: type,
      pageLength: 10,
      sortBy: "id",
      sortDirection: "desc",
      include_lunch: true,
    };

    setValue("start_date", tomorrow);
    setValue("end_date", fourteenDaysAfter);
    setValue("type", type);
    setFilters(filterParams);
    dispatch(fetchAppointments(1, filterParams));
    tableRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    else if (type === 2) {
      navigate("/billingual-requests", {
        state: {
          filterByFourteen: true,
        },
      });
    }
    else if (type === 3) {
      navigate("/translations", {
        state: {
          filterByFourteen: true,
        },
      });
    }
  };



  useEffect(() => {
    (async () => {
      const result = await dispatch(fetchInterpreterOptions());
      console.log("Prefetched interpreters:", result);
    })();
  }, [dispatch]);

  // Update languageState when languages change
  useEffect(() => {
    setLanguageState(
      languages?.map(val => ({
        label: val?.name || "",
        value: val?.id || ""
      })) || []
    );
  }, [languages]);

  // ========== LEGEND FILTERS ==========
  const filteredStatuses = React.useMemo(() => {
    const temp_array = [...legends];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0"
    })
    return temp_array;
  }, [legends]);

  const handleActiveLegend = (id, value) => {
    setSearchTerm("");
    if (value === "all") {
      setActiveLegends([id]);
      setStatusValues([]);
      setShowLunch(true);
      setShowDayOff(true);
      const allFilters = { ...getValues(), include_lunch: true };
      setFilters(allFilters);
      dispatch(fetchAppointments(1, allFilters));
    } else {
      setShowLunch(false);
      setShowDayOff(false);
      setActiveLegends((prev) => {
        const withoutAll = prev.filter((pid) => pid !== 0);
        let newActive, newStatuses;
        if (withoutAll.includes(id)) {
          newActive = withoutAll.filter((item) => item !== id);
          newStatuses = statusValues.filter((s) => s !== value);
        } else {
          newActive = [...withoutAll, id];
          newStatuses = [...statusValues, value];
        }
        setStatusValues(newStatuses);
        const currentFilters = {
          ...getValues(),
          status: newStatuses.length ? newStatuses : undefined,
          include_lunch: true,
        };
        setFilters(currentFilters);
        dispatch(fetchAppointments(1, currentFilters));
        return newActive;
      });
    }
  };

  // ========== LANGUAGES DROPDOWN ==========
  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  // ========== SCHOOL DROPDOWN ==========
  const filteredSchools = React.useMemo(() =>
    schools?.map(school => ({
      value: school?.id,
      label: school?.name
    })) || [], [schools]);

  const filteredSchoolLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchSchools(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true))
    return {
      options: result?.data?.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };

  // ========== INTERPRETER DROPDOWN ==========
  const interpreterOptions = React.useMemo(
    () =>
      interpreters?.map((i) => ({
        value: i.id,
        label:
          i.user?.name ||
          `${i.first_name ?? ""} ${i.last_name ?? ""}`.trim() ||
          "Unknown",
      })) || [],
    [interpreters]
  );

  const interpreterLoadOptions = async (inputValue, loadedOptions, { page }) => {
    return await dispatch(
      fetchInterpreterOptions(page, {
        pageLength: 10,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
      })
    );
  };

  // ========== FORM HANDLERS ==========
  const handleReset = () => {
    const today = moment().format("YYYY-MM-DD");
    setLanguageState([]);
    setValue("start_date", today);
    setValue("end_date", today);
    setValue("appointment_id", "");
    setValue("interpreter", null);
    setValue("school_id", null);
    setValue("type", null);
    setValue("language_ids", []);
    setActiveLegends([0]);
    setStatusValues([]);

    reset({
      start_date: today,
      end_date: today,
      appointment_id: "",
      interpreter: null,
      school_id: null,
      type: null,
      language_ids: [],
    });

    const emptyFilters = {
      start_date: today,
      end_date: today,
      pageLength: 10,
      sortBy: "id",
      sortDirection: "desc",
      include_lunch: true,
    };
    setFilters(emptyFilters);
    setCurrentPageSize(10);
    dispatch(fetchAppointments(1, emptyFilters));

    clearErrors();
  };





  console.log(total, 'dashboard')

  // ========== TABLE HANDLERS ==========
  const handleChange = (e) => {
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };

  const handleToggleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = appointmentData?.appointments?.map((item) => item.id.toString()) || [];
      setSelectedItems(allIds);
      setSelectAll(true);
    } else {
      setSelectedItems([]);
      setSelectAll(false);
    }
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  };

  const handleRemoveItems = () => {
    hideConfirmDialog();
    setSelectedItems([]);
    setSelectAll(false);
  };

  const handleAddAppointmentPopUp = (item) => {
    // This can be left empty if not needed in dashboard
  };

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchAppointments(currentPageNum, {
          ...filters,
          pageLength: currentPageSize,
          search: searchTerm,
          sortBy: sortBy,
          sortDirection: dir,
          include_lunch: true,
        })
      );
    };
    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                checked={selectAll}
                onChange={handleToggleSelectAll}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </th>

        <th>
          <TableHeaderItem
            title="appid"
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-1">
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Type"
            sortBy="type"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-1">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-1">
          <TableHeaderItem
            title="Interpreter"
            sortBy="interpreter"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-3">
          <TableHeaderItem
            title="Meeting Date & time"
            sortBy="date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="School"
            sortBy="school"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
      </tr>
    );
  }, [
    selectAll,
    searchTerm,
    sortConfig,
    currentPageNum,
    selectedItems,
    appointments,
    filters,
    currentPageSize
  ]);

  const renderTableContent = React.useCallback(() => {
    const lunchRows = showLunch ? lunchRecords?.map((lunch) => {
      const dateLabel = lunch?.date
        ? moment(lunch.date, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'N/A';
      const timeLabel = lunch?.start_time && lunch?.end_time
        ? `${moment(lunch.start_time, 'HH:mm').format('h:mm A')} – ${moment(lunch.end_time, 'HH:mm').format('h:mm A')}`
        : lunch?.start_time
          ? moment(lunch.start_time, 'HH:mm').format('h:mm A')
          : 'N/A';
      return (
        <tr key={lunch?.id}>
          <td className='p-0' style={LUNCH_ROW_STYLE}>
            <div className='row_check' style={{ ...LUNCH_EYE_STYLE, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px' }}>
              <i className="fa-solid fa-utensils" style={{ color: '#fff' }}></i>
            </div>
          </td>
          <td style={LUNCH_ROW_STYLE}>LUNCH</td>
          <td style={LUNCH_ROW_STYLE}>{lunch?.interpreter_name || 'N/A'}</td>
          <td style={LUNCH_ROW_STYLE}>Lunch Break</td>
          <td style={LUNCH_ROW_STYLE}>On Lunch</td>
          <td style={LUNCH_ROW_STYLE}>{lunch?.interpreter_name || 'N/A'}</td>
          <td style={LUNCH_ROW_STYLE}>{dateLabel} {timeLabel}</td>
          <td style={LUNCH_ROW_STYLE}>—</td>
          <td style={LUNCH_ROW_STYLE}>—</td>
        </tr>
      );
    }) : [];

    return (
      <>
      {appointmentData?.appointments &&
      appointmentData?.appointments?.map((appointment, index) => {
        // Hide day off rows if showDayOff is false
        // eslint-disable-next-line eqeqeq
        if (!showDayOff && appointment?.type == 4) return null;

        const serial = (currentPageNum - 1) * pageLength + index + 1;
        const typeLabels = {
          0: "Interpreting Request",
          1: "After Hours Request",
          2: "Bilingual Exams Request",
          4: "Day Off",
        };

        const rawDatetime = appointment?.date + " " + appointment?.start_time;
        const formattedDate = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss").format(
          "MMM D, YYYY HH:mm:ss"
        );

        // eslint-disable-next-line eqeqeq
        if (appointment?.type == 4) {
          const interpreterName = appointment?.interpreter
            ? `${appointment.interpreter.first_name || ''} ${appointment.interpreter.last_name || ''}`.trim()
            : 'N/A';
          const dayDateLabel = appointment?.date
            ? moment(appointment.date, 'YYYY-MM-DD').format('MMM D, YYYY')
            : 'N/A';
          return (
            <tr key={appointment.id}>
              <td className='p-0' style={DAY_OFF_ROW_STYLE}>
                <div className='row_check' style={{ ...DAY_OFF_EYE_STYLE, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px' }}>
                  <i className="fa-solid fa-ban" style={{ color: '#fff' }}></i>
                </div>
              </td>
              <td style={DAY_OFF_ROW_STYLE}></td>
              <td style={DAY_OFF_ROW_STYLE}>{interpreterName}</td>
              <td style={DAY_OFF_ROW_STYLE}>Day Off</td>
              <td style={DAY_OFF_ROW_STYLE}>—</td>
              <td style={DAY_OFF_ROW_STYLE}>{interpreterName}</td>
              <td style={DAY_OFF_ROW_STYLE}>{dayDateLabel}</td>
              <td style={DAY_OFF_ROW_STYLE}>—</td>
              <td style={DAY_OFF_ROW_STYLE}>—</td>
            </tr>
          );
        }

        return (
          <tr key={appointment.id}>
            <td style={getBackgroundStyle(appointment?.status)}>
              <div className="row_check">
                <span>{serial}</span>
                <label className="custom-checkbox checkbox">
                  <input
                    type="checkbox"
                    name="select-all"
                    data-value={appointment.id}
                    checked={selectedItems.includes(appointment.id.toString())}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
            </td>
            <td style={getBackgroundStyle(appointment?.status)}>
              <Link
                          className="link_preview"
                          to={`/appointments/view/${appointment?.id}`}
                        >
              {appointment?.appid}

                        </Link>
            </td>

            <td
              style={{
                ...getBackgroundStyle(appointment?.status),
                lineHeight: "1.5",
              }}
            >
              {appointment?.language?.name || appointment?.language_other}
            </td>
            <td style={getBackgroundStyle(appointment?.status)}>
              {typeLabels[appointment?.type] || ""}
            </td>

            <td style={getBackgroundStyle(appointment?.status)}>
              {appointment?.status}
            </td>

            <td style={getBackgroundStyle(appointment?.status)}>
              {appointment?.vendor_id != null && appointment?.vendor_interpreter
                ? `${appointment.vendor_interpreter?.first_name || ""} ${appointment.vendor_interpreter?.last_name || ""} - Excel`.trim()
                : `${appointment?.interpreter?.first_name || ""} ${appointment?.interpreter?.last_name || ""}`.trim()}
            </td>
            <td style={getBackgroundStyle(appointment?.status)}>
              {appointment?.date ? formattedDate : "N/A"}
            </td>
            <td style={getBackgroundStyle(appointment?.status)}>
              {appointment?.school?.name || "N/A"}
            </td>

            <td style={getBackgroundStyle(appointment?.status)}>
              {moment(appointment.created_at, "YYYY-MM-DD HH:mm").format(
                "MMM D, YYYY HH:mm"
              )}
            </td>
          </tr>
        );
      })}
      {lunchRows}
      </>
    );
  }, [appointmentData?.appointments, lunchRecords, showLunch, showDayOff, selectedItems, currentPageNum, pageLength]);

  return (
    <>
      <div className="content">
        <div className="row_main_head">
          <h2 className="main_heading">Dashboard</h2>
        </div>

        <div className="row_dash_1">
          <div className="card_table">
            <div className="interpreter p-4">
              <h2>Today</h2>
            </div>

            <div className="Table_data_show pt-0">
              <table>
                <thead>
                  <tr>
                    <th className="col-6">Today</th>
                    <th className="col-3 text-center">Registered</th>
                    <th className="col-3 text-center">To Cover</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard?.analytics?.todays_data?.map((service, index) => (
                    <tr
                      className="cursorPointer"
                      key={index}
                      onClick={() => {
                        viewAppointments(service?.value);
                      }}
                    >
                      <td>{service?.type}</td>
                      <td>{service?.assigned}</td>
                      <td>{service?.pending}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card_table">
            <div className="interpreter p-4">
              <h2>Next 14 Days</h2>
            </div>

            <div className="Table_data_show pt-0">
              <table>
                <thead>
                  <tr>
                    <th className="col-6">Today</th>
                    <th className="col-3 text-center">Registered</th>
                    <th className="col-3 text-center">To Cover</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard?.analytics?.fourteen_days?.map((service, index) => (
                    <tr
                      className="cursorPointer"
                      key={index}
                      onClick={() => {
                        nextFourteenDaysAppointments(service?.value);
                      }}
                    >
                      <td>{service?.type}</td>
                      <td>{service?.assigned}</td>
                      <td>{service?.pending}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* <div className="row_dash_1">
          <div className="card_table p-4">
            <GraphCard
              title="Interpreter Requests"
              categories={dashboard.graph?.months}
              seriesData={[
                { name: "Completed", data: type0Completed },
                { name: "Assigned", data: type0Assigned },
                { name: "Declined", data: type0Declined },
                { name: "Cancelled", data: type0Cancelled },
                { name: "Pending", data: type0Pending },
                { name: "Available", data: type0Available },
              ]}
            />

          </div>

          <div className="card_table p-4">
            <GraphCard
              title="Interpreter Requests for Evening School Events"
              categories={dashboard.graph?.months}
              seriesData={[
                { name: "Completed", data: type1Completed },
                { name: "Assigned", data: type1Assigned },
                { name: "Declined", data: type1Declined },
                { name: "Cancelled", data: type1Cancelled },
                { name: "Pending", data: type1Pending },
                { name: "Available", data: type1Available },
              ]}
            />
          </div>
        </div>

        <div className="row_dash_1">
          <div className="card_table p-4">
            <GraphCard
              title="Bilingual Exams"
              categories={dashboard.graph?.months}
              seriesData={[
                { name: "Completed", data: type2Completed },
                { name: "Assigned", data: type2Assigned },
                { name: "Declined", data: type2Declined },
                { name: "Cancelled", data: type2Cancelled },
                { name: "Pending", data: type2Pending },
                { name: "Available", data: type2Available },
              ]}
            />
          </div>
          <div className="card_table p-4">
            <GraphCard
              title="Translation Requests"
              categories={dashboard.graph?.months}
              seriesData={[
                { name: "Completed", data: type3Completed },
                { name: "Assigned", data: type3Assigned },
                { name: "Declined", data: type3Declined },
                { name: "Cancelled", data: type3Cancelled },
                { name: "Pending", data: type3Pending },
                { name: "Available", data: type3Available },
              ]}
            />
          </div>
        </div> */}

        {/* === Graphs Completed === */}

        <div className="card_table p-4">
          {/* Tabs */}
          {/* <div className="tabs_wrapper" data-active={activeTab}>
            {[
              { key: "appointments", label: "Appointments" },
              { key: "bilingual", label: "Bilingual Exams" },
              { key: "translations", label: "Translations" },
            ].map((tab) => (
              <div className="border_btn" key={tab.key}>
                <button
                  className={`button-bu ${activeTab === tab.key ? "active" : ""}`}
                  onClick={() => handleTabClick(tab.key)}
                >
                  <p>{tab.label}</p>
                </button>
              </div>
            ))}
          </div> */}

          <div className="card_table">
            <div className="button-sm forLegends p-3 gap-1">
              <LegendButton
                activeIds={activeLegends}
                options={filteredStatuses}
                handleClick={handleActiveLegend}
              />
              <div className={`border_btn ${showDayOff ? 'active_border' : ''}`}>
                <button
                  type="button"
                  className="button-bu"
                  style={{ backgroundColor: '#fd7e14' }}
                  onClick={() => {
                    const next = !showDayOff;
                    setShowDayOff(next);
                    if (next) { setActiveLegends([0]); setStatusValues([]); setShowLunch(true); }
                  }}
                >
                  <p>Day Off</p>
                </button>
              </div>
              <div className={`border_btn ${showLunch ? 'active_border' : ''}`}>
                <button
                  type="button"
                  className="button-bu"
                  style={{ backgroundColor: '#2e7d32' }}
                  onClick={() => {
                    const next = !showLunch;
                    setShowLunch(next);
                    if (next) { setActiveLegends([0]); setStatusValues([]); setShowDayOff(true); }
                  }}
                >
                  <p>Lunch</p>
                </button>
              </div>
            </div>
            <form
              onSubmit={handleSubmit((values) => {
                const params = {
                  start_date: values.start_date
                    ? moment(values.start_date).format("YYYY-MM-DD")
                    : null,
                  end_date: values.end_date
                    ? moment(values.end_date).format("YYYY-MM-DD")
                    : null,
                  appointment_id: values.appointment_id || "",
                  interpreter: values.interpreter || null,
                  type: values.type,
                  language_ids: values.language_ids || [],
                  status: statusValues || "",
                  school_id: values.school_id ?? null,
                  include_lunch: true,
                };
                setFilters(params);
                setSearchTerm("");
                dispatch(fetchAppointments(1, params));
              })}
              className="search_form_ad"
            >
              {/* Start Date */}
              <div className="row-primary dahboard_filter appointments">
                <DateRangeFilter control={control} />

                {/* Appointment ID */}
                <div className="row-primary">
                  <h2>Appointment ID</h2>
                  <Controller
                    name="appointment_id"
                    control={control}
                    render={({ field }) => (
                      <div className="input-basis basic_bases">
                        <input
                          {...field}
                          type="text"
                          className="input-in type_inp"
                          placeholder="Enter ID"
                        />
                      </div>
                    )}
                  />
                </div>

                {/* Interpreter */}
                <div className="row-primary" style={{ flexBasis: "40%" }}>
                  <h2>Interpreter</h2>
                  <div style={{ flex: 1 }}>
                    <Controller
                      name="interpreter"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="basic_bases">
                          <AsyncPaginate
                            menuPlacement="auto"
                            styles={{ ...selectCustomStyles }}
                            value={
                              field.value
                                ? interpreterOptions.find(
                                  (opt) =>
                                    String(opt.value) === String(field.value)
                                )
                                : null
                            }
                            loadOptions={interpreterLoadOptions}
                            isClearable
                            escapeClearsValue
                            onChange={(obj) => field.onChange(obj?.value ?? null)}
                            additional={{ page: 1 }}
                          />
                        </div>
                      )}
                    />
                  </div>
                </div>
                <div className="row-primary">
                  <h2>School</h2>
                  <Controller
                    name="school_id"
                    control={control}
                    render={({ field }) =>
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          menuPlacement='auto'
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={field.value ? filteredSchools?.find((opt) => field.value == opt.value) : ""}
                          loadOptions={filteredSchoolLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(obj) => {
                            field.onChange(obj?.value);
                          }}
                          additional={{
                            page: 1,
                          }}
                        />
                      </div>
                    }
                  />
                </div>
                <div className="row-primary">
                  <h2>Type</h2>
                  <Controller
                    name="type"
                    control={control}
                    render={({ field }) => (
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          {...field}
                          styles={selectCustomStyles}
                          options={[
                            { value: 0, label: "Interpreting Request" },
                            { value: 1, label: "After Hours Request" },
                            { value: 4, label: "Day Off" },
                          ]}
                          isClearable
                          placeholder="Select Type"
                          onChange={(option) => field.onChange(option !== null ? option.value : null)}
                          value={
                            field.value !== null && field.value !== undefined
                              ? [
                                { value: 0, label: "Interpreting Request" },
                                { value: 1, label: "After Hours Request" },
                                { value: 4, label: "Day Off" },
                              ].find((opt) => opt.value === field.value)
                              : null
                          }
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="row-primary">
                  <h2>Languages</h2>
                  <Controller
                    name="language_ids"
                    control={control}
                    render={({ field }) =>
                      <div style={{ width: "100%" }}>
                        <div style={{ width: "100%" }} className="multiselect">
                          <AsyncPaginate
                            menuPlacement='auto'
                            isMulti
                            styles={{
                              ...selectCustomStyles,
                            }}
                            value={languageState}
                            loadOptions={filteredLanguagesLoadOptions}
                            isClearable
                            escapeClearsValue
                            onChange={(selected) => {
                              setLanguageState(selected)
                              field.onChange(selected.map((opt) => opt.value))
                            }}
                            additional={{
                              page: 1,
                            }}
                          />
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="d-flex align-items-center justify-content-between px-3">
                <div className="row-primary row_10 w-100">
                  <button type="submit" className="main_button  green">
                    Search
                  </button>
                  {/* <SubmitButton handleSubmit={handleSubmit(onSubmit)} buttonType="button" btnText="Search" className={'green'} /> */}
                  <button
                    type="button"
                    className="main_button  lightBlue"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="mt-4">
            {/* {activeTab === "appointments" && */}
            <div ref={tableRef}>
              <ListLayout
                key={JSON.stringify(filters)}
                time={true}
                className={"appointment"}
                title=""
                buttonTitle="Add Appointment"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                addButtonDisabled={true}
                totalPages={appointmentData?.last_page || 1}
                fetchList={fetchAppointments}
                filtration={{...filters, pageLength: currentPageSize}}
                onPageSizeChange={(size) => {
                  setCurrentPageSize(size);
                  setFilters(prev => ({ ...prev, pageLength: size }));
                }}
                selectedItems={selectedItems}
                handleRemoveItems={handleRemoveItems}
                refAddutton={null}
                addForm={{ show: false, item: {} }}
                showConfirmDialog={() => setDeleteModal(true)}
                handleAddPopUp={handleAddAppointmentPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                loader={appointmentData?.loader || false}
                searchPlaceholder="Search Appointments ..."
                noOfItems={appointmentData?.total || 0}
                refAddPopUp="#addAppointmentPopUp"
                disableBootstrap={true}
                addformModal={false}
                styling="appointment"
              >
                {deleteModal && (
                  <ConfirmationModal
                    onClose={hideConfirmDialog}
                    isOpen={deleteModal}
                    onConfirm={handleRemoveItems}
                  />
                )}
              </ListLayout>
            </div>
            {/* } */}
            {/* {activeTab === "bilingual" &&
              <div ref={tableRef}>
                <ListTable data={dashboard?.appointments} filtration={filters} heading="Today's Bilingual Exams" link='billingual-requests' />
              </div>}
            {activeTab === "translations" &&
              <div ref={tableRef}>
                <TranslationListTable
                  link='translation'
                  translations={translations?.data || []}
                  total={totalTranslations}
                  currentPage={current_page}
                  pageLength={per_page}
                  fetchList={fetchList}
                />

              </div>} */}
          </div>
        </div>
      </div>
      {(loader || translationsState.loader) && <FullPageLoader />}
    </>
  );
}

export default Dashboard;